module.exports = __webpack_public_path__ + "static/media/flaunt-order-btn.6dece9d4.png";